// Exports
export default {
	"iconostasisIconWrapper": "iconostasisIconWrapper_RvUof",
	"iconWrapper": "iconWrapper_Oa9f9",
	"icon": "icon_NoK8Z",
	"spinner": "spinner_BsB5H",
	"rotate": "rotate_09G-N",
	"iconSuccess": "iconSuccess_X5Nzs",
	"iconError": "iconError_vtX7-",
	"image": "image_wu-aS",
	"text": "text_40sEM",
	"centered": "centered_nuEo4",
	"snackbar": "snackbar_moHHz",
	"withButtons": "withButtons_WWgpK",
	"iconFixedSize": "iconFixedSize_2g4mo",
	"button": "button_NNiHb",
	"waitingRoomNotification": "waitingRoomNotification_XcdCf"
};
